import React, { useEffect } from 'react';
import { useContext, useState } from 'react';
import { Button, Col, Container, Row, Dropdown } from 'react-bootstrap';
import { AuthContext } from '../../context/AuthContext';
import BreadCrumbs from '../BreadCrumbs/BreadCrumbs';
import { useAuth } from '../../hooks/useAuth';
import bellIcon from '../../assets/images/bell-icon.svg';
import { errorMessageString } from '../../helpers/utils';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import moment from 'moment';
import envelopeOpen from '../../assets/images/envelope-open.png';
import envelopeClose from '../../assets/images/envelope-close.png';
import newCircle from '../../assets/images/new-circle.png';
const Header = (props) => {
    const { logout, user, getToken } = useAuth();
    const sidebarHandler = props.sidebarHandler;
    const {
        // user,
        dispatch
    } = useContext(AuthContext);
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState();

    useEffect(() => {
        getNotification();
    }, []);
    const getNotification = async () => {
        setLoading(true);
        const token = getToken();
        if (token)
            new WebApiCalls()
                .userNotifications(token, user?._id)
                .then((res) => {
                    if (res?.code === 200) {
                        setNotifications(res?.data);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    let errorMessage = errorMessageString(err);

                    toast.error(errorMessage);
                });
    };
    const updateNotification = async (id, read) => {
        setLoading(true);
        const token = getToken();
        if (token)
            new WebApiCalls()
                .updateNotifications(token, id, { read: read })
                .then((res) => {
                    if (res?.code === 200) {
                        setNotifications((prevNotifications) => {
                            let indexFound = prevNotifications.findIndex((row) => row._id === res?.data?._id);
                            if (indexFound !== -1) {
                                prevNotifications[indexFound] = res?.data;
                            }
                            return prevNotifications;
                        });
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    let errorMessage = errorMessageString(err);

                    toast.error(errorMessage);
                });
    };

    return (
        <header className="app-head">
            <Container fluid>
                <Row className="align-items-center justify-content-between">
                    <Col className="align-items-center d-flex">
                        <div className="header-hamburger" onClick={sidebarHandler}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                        <h6 className="header-heading">
                            {/* {user.role},<span>{`${user.first_name} ${user.last_name}`}</span> */}
                            {/* <BreadCrumbs /> */}
                        </h6>
                    </Col>
                    <Col>
                        <h3 className="title-case">{user?.role}</h3>
                    </Col>
                    <Col>
                        <h6 className="profile-cont d-flex align-items-center justify-content-end gap-4">
                            <span className="user-name">{`${user?.name}`}</span>
                            <Dropdown>
                                <Dropdown.Toggle id="dropdown-basic" className="theme-transparent position-relative">
                                    <img src={bellIcon} alt="bellIcon" />
                                    {notifications?.some((row) => !row.read) && (
                                        <div className="position-absolute new-circle">
                                            <img src={newCircle} width={10} alt="newCircle" />
                                        </div>
                                    )}
                                </Dropdown.Toggle>

                                <Dropdown.Menu direction={'up-centered'} className="notifications-container">
                                    {notifications.map((row, index) => {
                                        return (
                                            <React.Fragment key={index}>
                                                <div className="position-relative p-2">
                                                    <Link to={`${row?.link}/${row?.booking}`} className="text-black">
                                                        {row?.content}
                                                    </Link>
                                                    <div className="d-flex justify-content-end detail-small-heading mt-3">
                                                        {moment(row?.createdAt).format('MM-DD-YYYY')}
                                                    </div>
                                                    {row?.read ? (
                                                        <div
                                                            onClick={() => updateNotification(row._id, false)}
                                                            className="position-absolute envelope-icon cursor-pointer"
                                                        >
                                                            <img src={envelopeOpen} alt="" />
                                                        </div>
                                                    ) : (
                                                        <div onClick={() => updateNotification(row._id, true)} className="position-absolute envelope-icon cursor-pointer">
                                                            <img src={envelopeClose} alt="" />
                                                        </div>
                                                    )}
                                                </div>
                                                {index < notifications.length - 1 && <Dropdown.Divider />}
                                            </React.Fragment>
                                        );
                                    })}
                                    {notifications?.length === 0 && <div className="text-center"> No new notifications.</div>}
                                </Dropdown.Menu>
                            </Dropdown>
                            {/* <Button className="theme-outline-cancel-btn" onClick={() => logout()}>
                                Logout
                            </Button> */}
                        </h6>
                    </Col>
                </Row>
            </Container>
        </header>
    );
};
export default Header;
